/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-use-before-define */
import axios from 'axios';
import get from 'lodash/get';
import getAppVersion from '../components/fseManagementSystem/utils/webViewUtils/getAppVersion';
import store from '../store';
import { LOCAL_STORAGE, FSM, SESSION_STORAGE } from './constants.json';
import { getItem } from './localStorage';
import { getItem as getSessionItem } from './sessionStorage';
import { hideLoader, isP4b, success } from '../actions/components';
import pushHawkeyeEvent from '../components/fseManagementSystem/utils/webViewUtils/pushHawkeyeEvent';
import logout from '../components/fseManagementSystem/utils/webViewUtils/logout';
import sendEventsToHawkeye from '../components/fseManagementSystem/utils/webViewUtils/sendEventsToHawkeye';
import constants from '../components/fseManagementSystem/shared/ErrorBoundary/localization';
import pulseEvent from './global/pulseEvent';
import urlConfig from './config';
import FSMCONSTANTS, {
  pulseEventActionConstants,
  pulseEventCategoryConstants,
} from '../components/fseManagementSystem/utils/FSMContants';
import { generateRequestHeaderForUrl } from './cryptoUtils';
import postman from './postman';
import { getCurrentLocation } from '../components/userProfile/utils/webViewUtils';
import { openViewDefaultModal } from '../actions/openModal';
import decryption from './decryption';
import getCryptoVersionKey from '../components/fseManagementSystem/utils/webViewUtils/getCryptoVersionKey';
import configFile from './global/configFile';

const envConfig = configFile(process.env.REACT_APP_ENV, process.env.INSTANCE);
const cryptoVersionKey = getCryptoVersionKey(
  envConfig.clientId,
  envConfig.hostId,
);
const decryptionKeyInfo = cryptoVersionKey && JSON.parse(cryptoVersionKey);

export default (function fetchData() {
  let startTime;
  let endTime;
  let responseTime;
  const hawkeyeEventJson = {};
  axios.interceptors.request.use(
    (request) => {
      const isRequestFsmEndpoint = !!request?.url.includes(
        envConfig?.fsm?.endpoint,
      );
      if (decryptionKeyInfo?.key && isRequestFsmEndpoint) {
        request.headers = {
          ...request.headers,
          e_enabled: true,
        };
      }
      startTime = Date.now();
      const isInternalAdmin = store?.getState()?.common?.isInternalAdmin;
      const xfseId = getSessionItem(SESSION_STORAGE.xFseId);
      if (
        isInternalAdmin &&
        xfseId &&
        request?.url?.indexOf(urlConfig.internalAdmin) < 0
      ) {
        request.headers = {
          ...request.headers,
          'x-fse-id': xfseId,
        };
      }
      // adding empId of TL in Header while ASM working as a TL in serviceFlow
      request.headers = {
        ...request.headers,
        ...getServiceFlowHeaderForAsmView(),
      };
      return request;
    },
    (error) => {
      startTime = Date.now();
      return Promise.reject(error);
    },
  );
  axios.interceptors.response.use(
    (response) => {
      const isResponseFsmEndpoint = !!response?.config?.url.includes(
        envConfig?.fsm?.endpoint,
      );
      const newState = store.getState();
      endTime = Date.now();
      responseTime = endTime - startTime;
      const { data, config, status, headers } = response;
      if (isP4b()) {
        hawkeyeEventJson.uri = config.url || '';
        hawkeyeEventJson.responseTime = responseTime.toString();
        hawkeyeEventJson.responseCode = response.status.toString();
        hawkeyeEventJson['x-app-rid'] = get(newState, 'fsm.correlationId', '');
        pushHawkeyeEvent(hawkeyeEventJson);
      } else {
        const dataObj = {};
        dataObj.uri = config.url || '';
        dataObj.correlationId = get(newState, 'fsm.correlationId', '');
        sendEventsToHawkeye(
          response.status,
          responseTime,
          Object.keys(dataObj).length,
          JSON.stringify(dataObj),
        );
      }
      if (decryptionKeyInfo && headers.e_enabled && isResponseFsmEndpoint) {
        const decryptedData = decryption(
          data,
          decryptionKeyInfo?.key,
          decryptionKeyInfo?.salt,
          decryptionKeyInfo?.iv,
        );
        response.data = JSON.parse(decryptedData);
      }
      if (data?.error) {
        const message = `${
          data?.error?.errorMsg || constants.GenericErrorText
        } (Status Code: ${data?.error?.errorCode || status})`;
        return Promise.reject({ ...response, response: { data: { message } } });
      }

      return response;
    },
    (error) => {
      try {
        if (error) {
          endTime = Date.now();
          responseTime = endTime - startTime;
          const newState = store.getState();
          const correlationId =
            newState && newState.fsm && newState.fsm.correlationId;
          if (error.response) {
            const { data, config, status } = error.response;
            console.log('inside error.response');
            if (isP4b()) {
              hawkeyeEventJson.uri = config.url || '';
              hawkeyeEventJson.responseTime = responseTime.toString();
              hawkeyeEventJson.responseCode = status.toString();
              hawkeyeEventJson.responseSize =
                Object.keys(data).length.toString();
              hawkeyeEventJson['x-app-rid'] = correlationId.toString();
              pushHawkeyeEvent(hawkeyeEventJson);
            } else {
              let obj = {};
              if (data === '') {
                obj = { correlationId };
              } else {
                obj = { data, correlationId };
              }
              obj.uri = config.url;
              sendEventsToHawkeye(
                status,
                responseTime,
                Object.keys(obj).length,
                JSON.stringify(obj),
              );
            }
            if ([410, 401].includes(data.status)) {
              store.dispatch(hideLoader());
              setTimeout(() => {
                logout();
              }, 5000);
              return store.dispatch(
                openViewDefaultModal(
                  FSMCONSTANTS.SESSION_EXPIRED,
                  'Error!',
                  'default',
                  'Ok',
                  undefined,
                  '50vw',
                  'string',
                  '',
                  '',
                  logout,
                  true,
                ),
              );
            }
            if (!error?.response?.data?.message) {
              error.response.data.message = `${
                data?.error?.errorMsg || constants.GenericErrorText
              } (Status Code: ${
                data?.error?.errorCode || error.response.status
              })`;
              if (isP4b()) {
                const { checkin, checkout } =
                  newState.fsm && newState.fsm.attendance;
                const designation = get(newState, 'fsm.designation', '');
                const empType = get(
                  newState,
                  'fsm.details.userInfo.empType',
                  '',
                );
                const team = get(newState, 'fsm.details.profiles[0].team', '');
                const empCode = get(
                  newState,
                  'fsm.details.userInfo.empCode',
                  '',
                );
                // p4b analytics
                if (checkin && !checkout) {
                  pulseEvent(
                    pulseEventCategoryConstants.ATTENDANCE,
                    pulseEventActionConstants.ATTENDANCE_CHECKIN_SCAN_ERROR,
                    designation,
                    empType,
                    team,
                    empCode,
                  );
                }
                store.dispatch(
                  success(
                    { errorMsgCheckIn: data.statusMessage },
                    FSM.ATTENDANCE.SUCCESS,
                  ),
                );
              }
            }
          } else {
            console.log('inside error.response else');
            if (!isP4b()) {
              const data = {};
              data.error = error.toString();
              data.correlationId = correlationId;
              data.uri = error.config.url;
              sendEventsToHawkeye(
                408,
                responseTime,
                Object.keys(data).length,
                JSON.stringify(data),
              );
              // FCA-6124
              if (
                (error.toString &&
                  error.toString().indexOf('10000ms exceeded') > -1) ||
                !window.navigator.onLine
              ) {
                store.dispatch(
                  success(
                    { errorMsg: FSMCONSTANTS.NETWORK_ERROR },
                    FSM.HOMEPAGE.SUCCESS,
                  ),
                );
                return Promise.resolve({});
              }
              // store.dispatch(openViewDefaultModal(FSMCONSTANTS.TIMEOUT_ERROR, "Error!", "default", "Ok", undefined, "50vw", "string"))
            }

            // For P4b
            const customMessage = { message: error };
            hawkeyeEventJson.uri = error.config.url;
            hawkeyeEventJson.responseCode = '408';
            hawkeyeEventJson.responseTime = responseTime.toString();
            hawkeyeEventJson.customMessage = JSON.stringify(customMessage);
            hawkeyeEventJson['x-app-rid'] = correlationId.toString;
            pushHawkeyeEvent(hawkeyeEventJson);
            store.dispatch(
              success(
                { errorMsg: FSMCONSTANTS.TIMEOUT_ERROR },
                FSM.ATTENDANCE.FAILURE,
              ),
            );
          }
        }
      } catch (exception) {
        console.log(exception);
      }
      store.dispatch(hideLoader());
      return Promise.reject(error);
    },
  );
  /**
   * @return {String}
   */
  function generateCoRelationID() {
    const timeStamp = Date.now();
    const randomNumber = Math.floor(Math.random() * 1000000).toString(16);
    return `${timeStamp}:${randomNumber}`;
  }
  /**
   * XMLHTTPRequest get method without any custom header.
   * @param {string} url to make get request
   * @param {Object} data send with get request
   * @return {void}
   */
  function getWithoutHeader(url, data = {}) {
    return axios({
      url,
      method: 'get',
      params: data,
      withCredentials: true,
    });
  }
  /**
   * XMLHTTPRequest post method.
   * @param {string} url to make post request
   * @param {Object} data send with post request
   * @param {Object} header send with post request
   * @return {void}
   */
  function putReq(url, data = {}, header = {}) {
    const currentStore = store.getState();
    let email = '';
    let ssoid = '';
    let mobile = '';
    if (currentStore && currentStore.oauth) {
      email = currentStore.oauth.email;
      ssoid = currentStore.oauth.custId;
      mobile = currentStore.oauth.mobile;
    }
    return axios({
      url,
      method: 'put',
      data,
      withCredentials: true,
      xsrfCookieName: 'X-MW-TOKEN',
      xsrfHeaderName: 'X-MW-TOKEN',
      headers: {
        phonenumber: mobile,
        ssoid,
        ...header,
      },
    });
  }

  /**
   * XMLHTTPRequest get method with custom headers.
   * @param {string} url to make get request
   * @param {Object} data send with get request
   * @param {Object} header send with get request
   * @return {void}
   */
  function getReq(url, data = {}, header = {}) {
    const currentStore = store.getState();
    let email = '';
    let ssoid = '';
    let mobile = '';
    if (currentStore && currentStore.oauth) {
      email = currentStore.oauth.email;
      ssoid = currentStore.oauth.custId;
      mobile = currentStore.oauth.mobile;
    }
    return axios({
      url,
      method: 'get',
      params: data,
      withCredentials: true,
      headers: {
        phonenumber: mobile,
        ssoid,
        ...header,
      },
    });
  }
  /**
   * XMLHTTPRequest post method.
   * @param {string} url to make post request
   * @param {Object} data send with post request
   * @param {Object} header send with post request
   * @return {void}
   */
  function postReq(url, data = {}, header = {}) {
    const currentStore = store.getState();
    let email = '';
    let ssoid = '';
    let mobile = '';
    if (currentStore && currentStore.oauth) {
      email = currentStore.oauth.email;
      ssoid = currentStore.oauth.custId;
      mobile = currentStore.oauth.mobile;
    }
    return axios({
      url,
      method: 'post',
      data,
      withCredentials: true,
      xsrfCookieName: 'X-MW-TOKEN',
      xsrfHeaderName: 'X-MW-TOKEN',
      headers: {
        phonenumber: mobile,
        ssoid,
        ...header,
      },
    });
  }
  /**
   * XMLHTTPRequest post (without ssoid and phone number header) method.
   * @param {string} url to make post request
   * @param {Object} data send with post request
   * @param {Object} header send with post request
   * @return {void}
   */
  function postWithoutDefaultHeader(url, data = {}, header = {}) {
    return axios({
      url,
      method: 'post',
      data,
    });
  }
  /**
   * XMLHTTPRequest post method to upload files to dms which dont need headers.
   * @param {string} url to make post request
   * @param {Object} filedata required to send with post request to upload file
   * @param {Object} postConfig required to send with post request to upload file
   * @return {void}
   */
  function uploadFileWithoutHeaders(url, filedata = {}, postConfig = {}) {
    const data = new FormData();
    for (const key in filedata) {
      if (Array.isArray(filedata[key])) {
        data.append(key, filedata[key][0], filedata[key][1]);
      } else {
        data.append(key, filedata[key]);
      }
    }
    // data.append("file",filedata);
    return axios({
      url,
      method: 'post',
      data,
      withCredentials: true,
      xsrfCookieName: 'X-DM-TOKEN',
      xsrfHeaderName: 'X-DM-TOKEN',
      ...postConfig,
    });
  }
  /**
   * XMLHTTPRequest post method to upload files.
   * @param {string} url to make post request
   * @param {Object} filedata required to send with post request to upload file
   * @param {Object} fileConfig required to send with post request to upload file
   * @return {void}
   */
  function uploadFile(url, filedata = {}, fileConfig = {}) {
    const currentStore = store.getState();
    let email = '';
    let ssoid = '';
    let mobile = '';
    if (currentStore && currentStore.oauth) {
      email = currentStore.oauth.email;
      ssoid = currentStore.oauth.custId;
      mobile = currentStore.oauth.mobile;
    }
    const data = new FormData();
    for (const key in filedata) {
      if (Array.isArray(filedata[key])) {
        data.append(key, filedata[key][0], filedata[key][1]);
      } else {
        data.append(key, filedata[key]);
      }
    }
    // data.append("file",filedata);
    return axios({
      url,
      method: 'post',
      data,
      withCredentials: true,
      xsrfCookieName: 'X-MW-TOKEN',
      xsrfHeaderName: 'X-MW-TOKEN',
      headers: {
        phonenumber: mobile,
        ssoid,
        email,
      },
      ...fileConfig,
    });
  }
  /**
   * XMLHTTPRequest post method to upload files with token.
   * @param {string} url to make post request
   * @param {Object} filedata required to send with post request to upload file
   * @param {object} headers
   * @return {void}
   */
  function uploadFileWithToken(url, filedata = {}, headers) {
    const localStorage = getItem(LOCAL_STORAGE.SESSION);
    const data = new FormData();
    for (const key in filedata) {
      if (Array.isArray(filedata[key])) {
        data.append(key, filedata[key][0], filedata[key][1]);
      } else {
        data.append(key, filedata[key]);
      }
    }
    // data.append("file",filedata);
    return axios({
      url,
      method: 'post',
      data,
      headers: {
        session_token: localStorage && localStorage.accessToken,
        ...headers,
      },
    });
  }

  /**
   * @param {*} url
   * @param {object} data
   * @param {*} headers
   * @return {Promise}
   */
  function dmsPostWithToken(url, data = {}, headers) {
    // const localStorage = 123;
    const correlationId = generateCoRelationID();
    store.dispatch(success({ correlationId }, FSM.REQUESTS.SUCCESS));
    console.log('dmsPostWithToken', correlationId);
    const localStorage = getItem(LOCAL_STORAGE.SESSION);
    return axios({
      url,
      method: 'post',
      data,
      timeout: 10000,
      headers: {
        session_token: localStorage && localStorage.accessToken,
        'x-app-rid': correlationId,
        ...headers,
      },
    });
  }
  /**
   * @param {*} url
   * @param {*} data
   * @param {*} headers
   * @return {Promise}
   */
  function getWithToken(url, data, headers, responseType) {
    // const localStorage = 123;
    const correlationId = generateCoRelationID();
    store.dispatch(success({ correlationId }, FSM.REQUESTS.SUCCESS));
    console.log(correlationId);
    let pgMid = '';
    let kybId = '';
    const localStorage = getItem(LOCAL_STORAGE.SESSION);
    if (localStorage) {
      pgMid = localStorage.pgMid || '';
      kybId = localStorage.kybId || '';
    }
    return axios({
      url,
      method: 'get',
      params: data,
      timeout: 10000,
      responseType,
      headers: {
        session_token: localStorage && localStorage.accessToken,
        pgMid,
        kybId,
        'x-app-rid': correlationId,
        ...headers,
      },
    });
  }

  function getWithCifToken(url, data, headers, responseType) {
    const correlationId = generateCoRelationID();
    store.dispatch(success({ correlationId }, FSM.REQUESTS.SUCCESS));
    return axios({
      url,
      method: 'get',
      params: data,
      crossDomain: true,
      withCredentials: true,
      timeout: 10000,
      responseType,
      headers: {
        'x-app-rid': correlationId,
        ...headers,
      },
    });
  }
  /**
   * @param {*} url
   * @param {*} data
   * @param {*} headers
   * @return {Promise}
   */
  function downloadZipFile(url, data, headers) {
    const correlationId = generateCoRelationID();
    store.dispatch(success({ correlationId }, FSM.REQUESTS.SUCCESS));
    return axios({
      url,
      method: 'get',
      params: data,
      crossDomain: true,
      withCredentials: true,
      timeout: 10000,
      responseType: 'arraybuffer',
      headers: {
        'x-app-rid': correlationId,
        ...headers,
      },
    });
  }

  function cifUploadFileWithToken(url, filedata = {}, headers) {
    const data = new FormData();
    for (const key in filedata) {
      if (Array.isArray(filedata[key])) {
        data.append(key, filedata[key][0], filedata[key][1]);
      } else {
        data.append(key, filedata[key]);
      }
    }
    return axios({
      url,
      method: 'post',
      data,
      crossDomain: true,
      withCredentials: true,
      headers: {
        ...headers,
      },
    });
  }

  function cifUploadFileWithTokenTMS(url, filedata = {}, processType) {
    const data = new FormData();
    data.append('process', processType);
    for (const key in filedata) {
      if (Array.isArray(filedata[key])) {
        data.append(key, filedata[key][0], filedata[key][1]);
      } else {
        data.append(key, filedata[key]);
      }
    }
    return axios({
      url,
      method: 'post',
      data,
      crossDomain: true,
      withCredentials: true,
    });
  }
  function postWithCifToken(url, data, headers) {
    const correlationId = generateCoRelationID();
    store.dispatch(success({ correlationId }, FSM.REQUESTS.SUCCESS));
    return axios({
      url,
      method: 'post',
      data,
      crossDomain: true,
      withCredentials: true,
      timeout: 10000,
      headers: {
        'x-app-rid': correlationId,
        ...headers,
      },
    });
  }
  function putWithCifToken(url, data, headers) {
    const correlationId = generateCoRelationID();
    store.dispatch(success({ correlationId }, FSM.REQUESTS.SUCCESS));
    return axios({
      url,
      method: 'put',
      data,
      crossDomain: true,
      withCredentials: true,
      timeout: 10000,
      headers: {
        'x-app-rid': correlationId,
        ...headers,
      },
    });
  }
  /**
    * @param {*} url
    * @param {object} data
    * @param {*} headers

    * @return {Promise}
    */
  function postWithToken(url, data = {}, headers) {
    // const localStorage = 123;
    const correlationId = generateCoRelationID();
    store.dispatch(success({ correlationId }, FSM.REQUESTS.SUCCESS));
    console.log(correlationId);
    let pgMid = '';
    let kybId = '';
    const localStorage = getItem(LOCAL_STORAGE.SESSION);
    if (localStorage) {
      pgMid = localStorage.pgMid || '';
      kybId = localStorage.kybId || '';
    }
    return axios({
      url,
      method: 'post',
      data,
      timeout: 10000,
      headers: {
        session_token: localStorage && localStorage.accessToken,
        pgMid,
        kybId,
        'x-app-rid': correlationId,
        ...headers,
      },
    });
  }
  /**
    * @param {*} url
    * @param {object} data
    * @param {*} headers

    * @return {Promise}
    */
  function getWithTokenV2(url, data = {}, headers) {
    // const localStorage = 123;
    const correlationId = generateCoRelationID();
    store.dispatch(success({ correlationId }, FSM.REQUESTS.SUCCESS));
    console.log(correlationId);
    let pgMid = '';
    let kybId = '';
    const localStorage = getItem(LOCAL_STORAGE.SESSION);
    if (localStorage) {
      pgMid = localStorage.pgMid || '';
      kybId = localStorage.kybId || '';
    }
    return axios({
      url,
      method: 'post',
      data,
      timeout: 10000,
      headers: {
        session_token: localStorage && localStorage.accessToken,
        pgMid,
        kybId,
        'x-app-rid': correlationId,
        ...headers,
      },
    });
  }

  function putWithToken(url, data = {}, headers) {
    // const localStorage = 123;
    const correlationId = generateCoRelationID();
    store.dispatch(success({ correlationId }, FSM.REQUESTS.SUCCESS));
    console.log(correlationId);
    let pgMid = '';
    let kybId = '';
    const localStorage = getItem(LOCAL_STORAGE.SESSION);
    if (localStorage) {
      pgMid = localStorage.pgMid || '';
      kybId = localStorage.kybId || '';
    }
    return axios({
      url,
      method: 'put',
      data,
      timeout: 10000,
      headers: {
        session_token: localStorage && localStorage.accessToken,
        pgMid,
        kybId,
        'x-app-rid': correlationId,
        ...headers,
      },
    });
  }

  /**
    * @param {*} url
    * @param {object} data
    * @param {*} headers

    * @return {Promise}
    */
  function oePostWithToken(url, data = {}, headers) {
    const localStorage = getItem(LOCAL_STORAGE.SESSION);
    return axios({
      url,
      method: 'post',
      data,
      timeout: 10000,
      headers: {
        session_token: localStorage && localStorage.accessToken,
        ...headers,
      },
    });
  }

  /**
    * @param {*} url
    * @param {object} data
    * @param {*} headers

    * @return {Promise}
    */
  function postCrossDomain(url, data = {}, headers) {
    return new Promise((resolve, reject) => {
      const xhttp = new XMLHttpRequest();
      xhttp.open('POST', url, true);
      xhttp.setRequestHeader(
        'Content-type',
        'application/x-www-form-urlencoded',
      );
      xhttp.send(data);
      xhttp.onerror = function (error) {
        console.log('** An error occurred during the transaction');
        reject(error);
      };
      xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          resolve(this.responseText);
        }
      };
    });
  }

  /**
    * @param {*} url
    * @param {object} data
    * @param {*} headers

    * @return {Promise}
    */
  function getCrossDomain(url, data = {}, headers = {}) {
    return new Promise((resolve, reject) => {
      const xhttp = new XMLHttpRequest();
      xhttp.open('GET', url);
      // xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      Object.keys(headers).forEach((e) => {
        xhttp.setRequestHeader(e, headers[e]);
      });
      xhttp.send();
      xhttp.onerror = function (error) {
        console.log('** An error occurred during the transaction');
        reject(error);
      };
      xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          resolve(this.responseText);
        }
      };
    });
  }
  /**
   * @param {*} url
   * @param {*} data
   * @param {*} headers
   * @return {Promise}
   */
  function postForUmp(url, data, headers) {
    const localStorage = getItem(LOCAL_STORAGE.SESSION);
    return axios({
      url,
      method: 'post',
      data,
      timeout: 10000,
      headers: {
        'x-user-token': localStorage && localStorage.accessToken,
        ...headers,
      },
    });
  }

  /**
   * XMLHTTPRequest post (without ssoid and phone number header) method.
   * @param {string} url to make post request
   * @param {Object} data send with post request
   * @param {Object} header send with post request
   * @return {void}
   */
  function postWithLocation(url, data = {}, header = {}) {
    header['X-MW-URL-CHECKSUM'] = generateRequestHeaderForUrl(url);
    const promise = new Promise((resolve, reject) => {
      const locationEvent = postman.subscribe(
        'LOCATION_RECEIVED',
        (location) => {
          const { errorCode, coords } = location;
          if (errorCode === 200) {
            console.log('API Call');
            resolve(
              axios({
                url,
                method: 'post',
                data,
                withCredentials: true,
                headers: {
                  ...header,
                  longitude: coords.longitude,
                  latitude: coords.latitude,
                },
              }),
            );
          } else {
            console.log('Location status false !');
            reject(false);
          }
          locationEvent.remove();
        },
      );
    });
    typeof getCurrentLocation === 'function' && getCurrentLocation();
    return promise;
  }

  /**
   * XMLHTTPRequest post method.
   * @param {string} url to make post request
   * @param {Object} data send with post request
   * @param {Object} header send with post request
   * @return {void}
   */
  function postRequest(url, data = {}, header = {}) {
    return axios({
      url,
      method: 'post',
      data,
      headers: {
        ...header,
      },
    });
  }
  return {
    getWithoutHeader,
    put: putReq,
    get: getReq,
    getWithToken,
    getWithTokenV2,
    getWithCifToken,
    postWithToken,
    post: postReq,
    uploadFile,
    postWithoutDefaultHeader,
    uploadFileWithoutHeaders,
    uploadFileWithToken,
    postCrossDomain,
    getCrossDomain,
    postForUmp,
    oePostWithToken,
    dmsPostWithToken,
    postWithLocation,
    generateCoRelationID,
    downloadZipFile,
    cifUploadFileWithToken,
    cifUploadFileWithTokenTMS,
    postWithCifToken,
    putWithCifToken,
    putWithToken,
    postRequest,
  };
})();

const getServiceFlowHeaderForAsmView = () => {
  const currentState = store.getState();
  const designation = currentState?.fsm?.designation || '';
  const emp_id = currentState?.serviceFlow?.emp_id || '';
  const loggedUserEmpId = currentState?.fsm?.details?.userInfo?.empCode || '';
  const isAsmLoggedIn = designation === FSMCONSTANTS.Event_Designation.ASM;
  const isTlLoggedIn = designation === FSMCONSTANTS.Event_Designation.TL;
  const isDelegatedTLHeader =
    (emp_id && loggedUserEmpId !== emp_id && { emp_id }) || {};
  const isAsmViewHeader = (emp_id && { emp_id }) || {};
  return isTlLoggedIn
    ? isDelegatedTLHeader
    : isAsmLoggedIn
    ? isAsmViewHeader
    : {};
};
